

























































































































































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import addTaskMixin from './addTaskMixin'
import BillApi from '@/api/bill2'

@Component({})
export default class Verify extends Mixins(addTaskMixin) {
	public onTaskAdd() {
		this.addForm.validateFields((err: any, values: any) => {
			if (!err) {
				if (!this.fileList.length) {
					return this.$message.error('请上传授权文件')
				}

				values = cloneDeep(values)
				values.authorizeInfoId = this.fileId
				values.authorizeInfoName = this.picName
				values.issueDate = values.issueDate.format('YYYYMMDD')

				this.addLoading = true
				BillApi.checkInvoice(values)
					.then((res: any) => {
						this.orderId = res.data
						this.pollingAdd(
							{ orderId: this.orderId },
							() => {
								this.onFailOk()
							},
							() => {
								this.onOk()
							}
						)
					})
					.finally(() => {
						this.addLoading = false
					})
			}
		})
	}
}
